import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-modal-tgr',
  templateUrl: './modal-tgr.component.html',
  styleUrls: ['./modal-tgr.component.scss']
})
export class ModalTgrComponent {
  @Input() rut = '';
  @Input() reporteTesoreria: any; // this.reporteTesoreria
  public reporte: any = null;

  constructor(
    public dialogRef: MatDialogRef<ModalTgrComponent>,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.rut = data.rut;
    if(data?.reporteTesoreria && Object.keys(data?.reporteTesoreria).length > 0){
      this.reporteTesoreria = data?.reporteTesoreria;
      this.mapeosReporte();
    }
  }

  mapeosReporte(): void {
    this.reporte = {
      montoTotalVentaMorosaTGR: null,
      deudaFiscal: [],
      convenioVigentes: {
        body: [],
        totales: {}
      }

    }
    
    this.reporte.montoTotalVentaMorosaTGR = this.utilsService.getVentaTotalMorosaTGR(this.reporteTesoreria);
    this.setDeudaFiscal();
    this.setConveniosVigentes();
  }

  setDeudaFiscal(): any {
    const deudaFiscal = this.reporteTesoreria?.deudas?.fiscales?.detalle?.deudas || [];
    if(deudaFiscal && deudaFiscal.length > 0){
      this.reporte.deudaFiscal = deudaFiscal.map((deuda: any) => {
        return {
          ...deuda,
          rut: this.rut,
          girador: deuda?.formulario == '21' ? 'SII' : ''
        };
      });
    }
  }

  setConveniosVigentes(): any {
    const conveniosVigentes = this.reporteTesoreria?.convenios?.vigentes?.detalle || [];
    if(conveniosVigentes && conveniosVigentes.length > 0){
      this.reporte.convenioVigentes.body = conveniosVigentes;
      this.addDatosToConvenio(this.reporte.convenioVigentes.body);
      if(this.reporte.convenioVigentes.body.length > 0){
        this.reporte.convenioVigentes.body.forEach((convenio: any) => {
          convenio.montoMoroso = ((Number(convenio?.datos?.monotCuotaFija) || 0) * (Number(convenio?.datos?.cuotasVencidas) || 0)); // / 1000
        });
        this.calcularTotalesConveniosVigentes();
      }
    }
  }

  addDatosToConvenio(convenios: any[]) {
    convenios.forEach((convenio) => {
      this.searchDatosConvenioByResolucion(convenio)
    })
  }

  searchDatosConvenioByResolucion(itemConvenio: any) {
    const resolucion = itemConvenio.resolucion.toString();
    const convenioVigenteDatos = this.getConveniosVigentesDatos().find(element => element.resolucion === resolucion);
    if(convenioVigenteDatos){
      itemConvenio.datos = convenioVigenteDatos.detalle.informacion
      itemConvenio.datos.cuotas = convenioVigenteDatos.cuotas
      itemConvenio.datos.deudas = convenioVigenteDatos.detalle.deudas
      itemConvenio.datos.tipoDeuda = convenioVigenteDatos.detalle.tipoDeuda
      itemConvenio.datos.tipoPage = convenioVigenteDatos.tipoPago
      itemConvenio.datos.seeCuotas = false;
      return
    } 

    const convenioCaducado = this.getConveniosCaducadosDatos().find(element => element.resolucion === resolucion);
    if(convenioCaducado){
      itemConvenio.datos = convenioCaducado.detalle.informacion
      itemConvenio.datos.cuotas = convenioCaducado.cuotas
      itemConvenio.datos.deudas = convenioCaducado.detalle.deudas
      itemConvenio.datos.tipoDeuda = convenioCaducado.detalle.tipoDeuda
      itemConvenio.datos.tipoPage = convenioCaducado.tipoPago
      itemConvenio.datos.seeCuotas = false;
      return
    }

    const convenioPagado = this.getConveniosPagadosDatos().find(element => element.resolucion === resolucion);
    if(convenioPagado) {
      itemConvenio.datos = convenioPagado.detalle.informacion
      itemConvenio.datos.cuotas = convenioPagado.cuotas
      itemConvenio.datos.deudas = convenioPagado.detalle.deudas
      itemConvenio.datos.tipoDeuda = convenioPagado.detalle.tipoDeuda
      itemConvenio.datos.tipoPage = convenioPagado.tipoPago
      itemConvenio.datos.seeCuotas = false;
      return
    }
  }

  getConveniosVigentesDatos(): any[] {
    return this.reporteTesoreria?.convenios?.vigentes?.datos || []
  }

  getConveniosCaducadosDatos(): any[] {
    return this.reporteTesoreria?.convenios?.caducados?.datos || [];
  }

  getConveniosPagadosDatos(): any[] {
    return this.reporteTesoreria?.convenios?.pagados?.datos || [];
  }

  calcularTotalesConveniosVigentes(): void {
    this.reporte.convenioVigentes.totales = {
      totalMontoMoroso: 0,
      totalCuotasVencidas: 0,
      totalSaldo: 0
    };
    this.reporte.convenioVigentes.body.forEach((convenio: any) => {
      this.reporte.convenioVigentes.totales.totalMontoMoroso += Number(convenio?.montoMoroso) || 0;
      this.reporte.convenioVigentes.totales.totalCuotasVencidas += Number(convenio?.datos?.cuotasVencidas) || 0;
      this.reporte.convenioVigentes.totales.totalSaldo += Number(convenio?.montoLiquidado) || 0;
    });
  }

  close() {
    this.dialogRef.close();
  }

  descargarPDF(): void {
    const element = document.getElementById('printButtonModalTgr');
    setTimeout(() => {
      if(element){
        element.click();
      } else {
        console.error('Elemento no encontrado');
      }
    }, 500);
  }
}
